/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Navbar from "../../components/Navbar";
import ReferralDash from "../../components/ReferralDashboard";
import { backendUrlByEnv, LOGIN } from "../../constants/routes";

const ReferralDashboard = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.referralDashboard?.hasAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <ReferralDash adminConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default ReferralDashboard;
